module.exports = __webpack_public_path__ + "img/home-img.409c2a18.svg";